var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrders(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.75 3V22C20.75 22.278 20.596 22.533 20.35 22.663C20.104 22.793 19.807 22.776 19.577 22.619L17.082 20.916L14.723 22.609C14.44 22.813 14.054 22.794 13.792 22.564L12 20.997L10.208 22.564C9.946 22.794 9.56 22.813 9.277 22.609L6.918 20.916L4.423 22.619C4.193 22.776 3.896 22.793 3.65 22.663C3.404 22.533 3.25 22.278 3.25 22V3C3.25 2.034 4.033 1.25 5 1.25H19C19.967 1.25 20.75 2.034 20.75 3Z",
    fill: "#CDD2D7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 10.75H8C7.586 10.75 7.25 10.414 7.25 10C7.25 9.586 7.586 9.25 8 9.25H16C16.414 9.25 16.75 9.586 16.75 10C16.75 10.414 16.414 10.75 16 10.75Z",
    fill: "#637381"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 6.75H8C7.586 6.75 7.25 6.414 7.25 6C7.25 5.586 7.586 5.25 8 5.25H16C16.414 5.25 16.75 5.586 16.75 6C16.75 6.414 16.414 6.75 16 6.75Z",
    fill: "#637381"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 14.75H8C7.586 14.75 7.25 14.414 7.25 14C7.25 13.586 7.586 13.25 8 13.25H12C12.414 13.25 12.75 13.586 12.75 14C12.75 14.414 12.414 14.75 12 14.75Z",
    fill: "#637381"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrders);
export default __webpack_public_path__ + "static/media/Orders.8d8fa50710904d25d0911b4e152693d2.svg";
export { ForwardRef as ReactComponent };